import React from "react"
import { Header, Footer } from "./components"
import BookingForm from "@/components/BookingForm"
import FloatingWidgets from "@/components/FloatingWidgets"

interface WebTTMIProps {
  children: React.ReactNode
}

const WebTTMI: React.FC<WebTTMIProps> = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <BookingForm />
      <main className="flex-grow">{children}</main>
      <Footer />
      <FloatingWidgets />
    </div>
  )
}

export default WebTTMI
